// extracted by mini-css-extract-plugin
export default {"socketTypes":"add-update-controllers_socketTypes__TGND5","unlinkCard":"add-update-controllers_unlinkCard__hnVbd"};